import {Component, OnDestroy, OnInit} from '@angular/core';
import * as pbi from 'powerbi-client';
import {ViewMode, Permissions, TokenType} from 'powerbi-models';
@Component({
    standalone: false,
    selector: 'particle-pbi-playground',
  templateUrl: './pbi-playground.component.html',
  styleUrls: ['./pbi-playground.component.scss']
})
export class PbiPlaygroundComponent implements OnInit, OnDestroy {
  reportConfig: any;
  private powerbi: any;
  report: any;
  constructor() { }

  ngOnInit() {
    this.reportConfig = JSON.parse(localStorage.getItem('reportConfig'));
    console.log(this.reportConfig);
    setTimeout(()=>{
      this.displayReport();
    }, 100)
  }

  private displayReport() {
    const models = pbi.models;
    const config = {
      type: 'qna',
      embedUrl: `https://app.powerbi.com/qnaEmbed?groupId=${this.reportConfig.groupId}`,
      viewMode : models.QnaMode.Interactive,
      datasetIds: [this.reportConfig.datasetId],
      tokenType: TokenType.Embed,
      permissions: Permissions.All,
      accessToken: this.reportConfig.embedToken
    };
    this.powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory
    );
    const reportsContainer = <HTMLElement>document.getElementById(
      'reportsContainer'
    );
    if (reportsContainer) {
      this.powerbi.reset(reportsContainer);
      this.report = this.powerbi.embed(reportsContainer, config);
    }
    //this.report = this.powerbi.embed(reportsContainer, config)
  }
  ngOnDestroy(): void {
  }
}
